export const createDownload = async (
  response?: Response,
  filename?: string,
  contentType?: string,
) => {
  if (!response) {
    return;
  }

  const chunks: Uint8Array[] = [];
  const reader = response.body?.getReader();

  if (!reader) {
    return;
  }

  let done = false;
  do {
    const result = await reader.read();
    done = result.done;
    if (!done && result.value) {
      chunks.push(result.value);
    }
  } while (!done);

  const blob = new Blob(chunks, { type: contentType ?? 'text/plain' });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename ?? 'download';
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
};
